'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '1b5br720WBWnCdm4FChJDOKmRePdwM8MKivetZmp5eVc';